import styles from "./BookSessionScreen.module.scss";

import { useTranslation } from "react-i18next";

import { PageContainer } from "@/modules/shared/components/PageContainer";
import { SessionBookingWidget } from "@/modules/shared/components/SessionBookingWidget";
import { ShortUrlFlow } from "@/modules/tracking/consts/ShortUrl";
import { usePageLoaded } from "@/modules/tracking/hooks/usePageLoaded";
import { useShortUrlFlowAbandonment } from "@/modules/tracking/hooks/useShortUrlFlowAbandonment";
import { Route } from "@/routes/$sessionCode/book";

export function BookSessionScreen() {
  const { bookNewSession } = Route.useLoaderData();
  const { t } = useTranslation();
  useShortUrlFlowAbandonment();
  usePageLoaded({
    flow: ShortUrlFlow.Book,
    session_id: null,
    coach_id: bookNewSession.coach.id,
    time_until_session_start_minutes: null,
    is_first_visit: true,
    has_joined_previously: false,
  });

  return (
    <PageContainer variant="centered">
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.title}>{t("bookSession.title")}</span>
          <span className={styles.subtitle}>
            {t("bookSession.description")}
          </span>
        </div>
        <SessionBookingWidget
          coachId={bookNewSession.coach.id}
          coachName={bookNewSession.coach.name}
          customerId={bookNewSession.customer.id}
          memberName={bookNewSession.customer.fullName}
          memberEmail={bookNewSession.customer.email}
        />
      </div>
    </PageContainer>
  );
}
